/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbTitrePedagogiqueDto } from './FcbTitrePedagogiqueDto';
import {
    FcbTitrePedagogiqueDtoFromJSON,
    FcbTitrePedagogiqueDtoFromJSONTyped,
    FcbTitrePedagogiqueDtoToJSON,
} from './FcbTitrePedagogiqueDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbTitrePedagogiqueDtoPaginatedResults
 */
export interface FcbTitrePedagogiqueDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbTitrePedagogiqueDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbTitrePedagogiqueDto>}
     * @memberof FcbTitrePedagogiqueDtoPaginatedResults
     */
    results?: Array<FcbTitrePedagogiqueDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbTitrePedagogiqueDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbTitrePedagogiqueDtoPaginatedResults interface.
 */
export function instanceOfFcbTitrePedagogiqueDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbTitrePedagogiqueDtoPaginatedResultsFromJSON(json: any): FcbTitrePedagogiqueDtoPaginatedResults {
    return FcbTitrePedagogiqueDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbTitrePedagogiqueDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbTitrePedagogiqueDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbTitrePedagogiqueDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbTitrePedagogiqueDtoPaginatedResultsToJSON(value?: FcbTitrePedagogiqueDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbTitrePedagogiqueDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

